module.exports = __webpack_public_path__ + "img/SPC_Sword2 Clean OneMaterial.f8c906cb.png";